import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { UserRightsService } from "../services/user-rights.service";
import { NavigationNoticeService } from "../services/navigation-notice.service";
import { LANDING_PATH } from "../tabs";

/**
 * Role-based guard. Reads `route.data.requiredRole` (e.g. "SuperUser",
 * "Admin") and defers to UserRightsService's role-hierarchy check. That data is
 * published from the tab's own `requiredRole` (src/app/tabs.ts), which is also
 * what hides the tab, so the two cannot disagree. On failure, explains why in a
 * notice and redirects to the landing tab rather than the login screen — the user is authenticated, just not authorized
 * for this section. The tabs they cannot reach are hidden, so this only fires on
 * a typed URL or a stale bookmark, where a silent redirect looks like a bug.
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const userRights = inject(UserRightsService);
  const notice = inject(NavigationNoticeService);

  const requiredRole = route.data?.["requiredRole"] as string | undefined;
  if (!requiredRole || userRights.getUserRightLevel(requiredRole)) {
    return true;
  }

  notice.accessDenied();
  return router.createUrlTree([LANDING_PATH]);
};
